import React from "react";
import '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBriefcase, faGraduationCap, faCertificate } from '@fortawesome/free-solid-svg-icons';
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import '../assets/styles/Timeline.scss'

function Timeline() {
  return (
    <div id="history">
      <div className="items-container">
        <h1>Career History & Education</h1>
        <VerticalTimeline>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: 'white', color: 'rgb(39, 40, 34)' }}
            contentArrowStyle={{ borderRight: '7px solid  white' }}
            date="Oct 2018 - Present"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Unity Developer</h3>
            <h4 className="vertical-timeline-element-subtitle"><a href="https://epicvr.pl/en/" target="_blank" rel="noreferrer" style={{ color: '#007BFF', textDecoration: 'none' }}>EpicVR.pl</a>, Kraków</h4>
            <ul style={{ listStyleType: "disc", paddingLeft: "20px", marginTop: "15px", lineHeight: "1.6" }}>
              <li>Delivering projects on time, both independently and in a team, using the Unity game engine for Android, iOS, Desktop, and Hololens platforms. Utilizing VR, AR, and XR technologies with SRP, URP, and HDRP. Developing single-player and multiplayer (Photon) projects;</li>
              <li>Developing solutions based on ASP.NET MVC servers, including the design and creation of T-SQL/MySQL and SQLite databases, as well as establishing communication with the Unity engine;</li>
              <li>Proficiency in creating optimized software for mobile devices and Oculus Go/Quest/Quest2, HTC Vive/Index, Samsung Gear VR, Hololens and Hololens 2, Hi5 VR Gloves, and CaptoGlove;</li>
              <li>Writing shaders (Shader Graph) and creating particle systems (Particle System and VFX Graph);</li>
              <li>Writing technical documentation and Game Design Documents (GDD), as well as project management using Scrum methodology;</li>
              <li>Optimizing solutions (for performance and quality) in the Unity engine, as well as refactoring code;</li>
              <li>Level design, setting up and baking lighting; audio creation and editing; creating simple 3D models (Blender) with UV mapping.</li>
            </ul>
          </VerticalTimelineElement>

          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="Jul 2017 - Aug 2017"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">ASP.NET Developer</h3>
            <h4 className="vertical-timeline-element-subtitle"><a href="https://www.linkedin.com/company/newind-sp--z-o-o-/?originalSubdomain=pl" target="_blank" rel="noreferrer" style={{ color: '#007BFF', textDecoration: 'none' }}>Newind S.A.</a>, Wrocław</h4>
            <p>
              One-month professional internship. Programming web solutions according to given requirements in C#,
              JavaScript, and HTML, utilizing ASP.NET MVC, EntityFramework, Git, and Devexpress tools.
            </p>
          </VerticalTimelineElement>

          <VerticalTimelineElement
            className="vertical-timeline-element--education"
            date="Oct 2015 - Jul 2018"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faGraduationCap} />}
          >
            <h3 className="vertical-timeline-element-title"><a href="https://www.ue.katowice.pl/en.html" target="_blank" rel="noreferrer" style={{ color: '#007BFF', textDecoration: 'none' }}>University of Economics in Katowice</a></h3>
            <h4 className="vertical-timeline-element-subtitle">Bachelor's Degree in Computer Science</h4>
            <p>
              Specialization: Game and Mobile Application Programming
            </p>
          </VerticalTimelineElement>

          <VerticalTimelineElement
            className="vertical-timeline-element--education"
            date="Apr 2018"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faCertificate} />}
          >
            <h3 className="vertical-timeline-element-title"><a href="https://www.kodolamacz.pl/" target="_blank" rel="noreferrer" style={{ color: '#007BFF', textDecoration: 'none' }}>Java Programming Certificate</a></h3>
            <h4 className="vertical-timeline-element-subtitle">Kodolamacz.pl</h4>
            <p>
              The workshop included 120 lesson hours of lectures and exercises in Java programming,
              covering topics such as OOP, GOF patterns, GRASP, SOLID, Clean Code, TDD, web applications,
              JPA, and SCM. To pass, the participant completed two projects using technologies: Eclipse/Idea,
              Jetty, Heroku Cloud, Maven, GIT, JUnit, Mockito, AssertJ, Spring, Spring MVC, Spring Data, JPA,
              PostgreSQL, Thymeleaf, REST, and Robocode.
            </p>
          </VerticalTimelineElement>
        </VerticalTimeline>
      </div>
    </div>
  );
}

export default Timeline;